import { render } from "./model-tree.html?vue&type=template&id=04209c9d&scoped=true&ts=true"
import script from "./model-tree.ts?vue&type=script&lang=ts"
export * from "./model-tree.ts?vue&type=script&lang=ts"

import "./model-tree.scss?vue&type=style&index=0&id=04209c9d&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04209c9d"]])

export default __exports__